import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import PersonIcon from '@material-ui/icons/Person';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { useHistory, useParams } from 'react-router-dom';
import PasswordInput from './../components/PasswordInput';
import FormHelperText from '@material-ui/core/FormHelperText';

const axios = require('axios');
const jwt = require('jsonwebtoken');
const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  formJustify: {
    marginTop: theme.spacing(1),
    justifyContent: 'center',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const RequestPasswordReset = () => {
  let [linkExpired, setLinkExpired] = useState(false);
  let [counter, setCounter] = useState(10);
  let [errorMsg, setErrorMsg] = useState('');
  let [instructionMsg, setInstructionMsg] = useState('');
  let [values, setValues] = useState({
    password: '',
    confirmPassword: '',
    showPassword: false,
    showConfirmPW: false,
  });

  let { token: userToken } = useParams();
  useEffect(() => {
    jwt.verify(userToken, 'secret', (err, decoded) => {
      if (err) {
        setLinkExpired(true);
        setErrorMsg(`Invalid link. Redirecting in ${counter}...`);
      }
    });
  }, []);

  useEffect(() => {
    counter >= 0 &&
      setTimeout(() => {
        setCounter(counter - 1);
        if (linkExpired) {
          setErrorMsg(`Invalid link. Redirecting in ${counter}...`);
        }
      }, 1000);
  }, [counter]);

  let history = useHistory();
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleClickShowPasswordCmPW = () => {
    setValues({ ...values, showConfirmPW: !values.showConfirmPW });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const classes = useStyles();
  let dialog = <></>;

  let pageHeader = (
    <>
      <Avatar className={classes.avatar}>
        <PersonIcon />
      </Avatar>
      <Typography component='h1' variant='h5'>
        Change Password
      </Typography>
    </>
  );

  let passwordChangeError = false;
  let confirmPasswordChangeError = false;
  let passwordMisMatchErrorMsg = null;

  if (!values.password) {
    passwordChangeError = true;
  }

  if (!values.password) {
    confirmPasswordChangeError = true;
  }

  let matchingPassword = values.password === values.confirmPassword;

  let isPasswordStrong = false;
  let isConfirmedPasswordStrong = false;
  let passwordOrConfirmPasswordFilled =
    values.password || values.confirmPassword;

  let password = values.password;
  let confirmedPassword = values.confirmPassword;

  if (password.match(/^(?=.*?[A-Z])(?=.*?[0-9]).{8,}$/)) {
    isPasswordStrong = true;
  }

  if (confirmedPassword.match(/^(?=.*?[A-Z])(?=.*?[0-9]).{8,}$/)) {
    isConfirmedPasswordStrong = true;
  }

  if (values.password && !isPasswordStrong) {
    passwordChangeError = true;
  }

  if (values.confirmPassword && !isConfirmedPasswordStrong) {
    passwordChangeError = true;
  }

  if (values.password && values.confirmPassword) {
    if (matchingPassword && !isPasswordStrong) {
      passwordChangeError = true;
    }

    if (matchingPassword && !isConfirmedPasswordStrong) {
      confirmPasswordChangeError = true;
    }
    if (!matchingPassword) {
      passwordChangeError = true;
      confirmPasswordChangeError = true;
    }
  }

  let alertTag = <></>;
  let errorMessage;
  if (!matchingPassword && passwordOrConfirmPasswordFilled) {
    if (!values.confirmPassword) {
      if (!isPasswordStrong) {
        errorMessage = (
          <>
            <div>* Please confirm your password</div>
            <div>&nbsp;</div>
            <div>
              * Password must have at least 8 characters and contain two of the
              following: uppercase and numbers.
            </div>
          </>
        );
      } else {
        errorMessage = '* Please confirm your password';
      }
    }

    if (!values.password) {
      errorMessage = '* Please fill in your password field';
    }

    if (values.password && values.confirmPassword) {
      if (
        matchingPassword &&
        (!isPasswordStrong || !isConfirmedPasswordStrong)
      ) {
        errorMessage =
          '* Password must have at least 8 characters and contain two of the following: uppercase and numbers.';
      }
      if (!isPasswordStrong) {
        errorMessage = (
          <>
            <div>* Confirm password and password mismatch</div>
            <div>&nbsp;</div>
            <div>
              * Password must have at least 8 characters and contain two of the
              following: uppercase and numbers.
            </div>
          </>
        );
      } else {
        errorMessage = '* Confirm password and password mismatch';
      }
    }
  }
  if (errorMessage) {
    passwordChangeError = true;
    confirmPasswordChangeError = true;
    alertTag = (
      <>
        <div>&nbsp;</div>
        <span style={{ color: 'red' }}>{errorMessage}</span>
        <div>&nbsp;</div>
      </>
    );
  }

  let formError = passwordChangeError && confirmPasswordChangeError;
  console.log(formError);

  let form = (
    <form className={classes.form} noValidate>
      <FormControl fullWidth className={classes.margin} variant='outlined'>
        <InputLabel htmlFor='outlined-adornment-password'>Password</InputLabel>
        <OutlinedInput
          id='outlined-adornment-password'
          error={passwordChangeError}
          type={values.showPassword ? 'text' : 'password'}
          onChange={handleChange('password')}
          endAdornment={
            <InputAdornment position='end'>
              <IconButton
                aria-label='toggle password visibility'
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge='end'>
                {values.showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
          labelWidth={80}
        />
        <FormHelperText style={{ color: 'red' }} id='component-error-text'>
          {!values.password ? 'Password field is required' : null}
        </FormHelperText>
      </FormControl>
      <div>&nbsp;</div>
      <FormControl fullWidth className={classes.margin} variant='outlined'>
        <InputLabel htmlFor='outlined-adornment-password'>
          Confirm Password
        </InputLabel>
        <OutlinedInput
          id='outlined-adornment-password'
          error={confirmPasswordChangeError}
          type={values.showConfirmPW ? 'text' : 'password'}
          onChange={handleChange('confirmPassword')}
          endAdornment={
            <InputAdornment position='end'>
              <IconButton
                aria-label='toggle password visibility'
                onClick={handleClickShowPasswordCmPW}
                onMouseDown={handleMouseDownPassword}
                edge='end'>
                {values.showConfirmPW ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
          labelWidth={140}
        />
        <FormHelperText style={{ color: 'red' }} id='component-error-text'>
          {!values.confirmPassword ? 'Password field is required' : null}
        </FormHelperText>
      </FormControl>
      {alertTag}
      <div>
        <Button
          // disabled={formError}
          onClick={(event) => {
            event.preventDefault();

            let newpassword = values.password;
            let confirmpassword = values.confirmPassword;

            jwt.verify(userToken, 'secret', (err, decoded) => {
              if (!formError) {
                if (newpassword === confirmpassword) {
                  let { username } = decoded['data'];
                  let body = {
                    username: username,
                    password: newpassword,
                  };
                  axios
                    .post(
                      `${process.env.REACT_APP_API}/changeUserPassword`,
                      body
                    )
                    .then((result) => {
                      console.log(result);
                      setInstructionMsg(
                        'Password has been changed, confirmation email has been sent'
                      );
                      setTimeout(() => {
                        history.push('/login');
                      }, 3000);
                    });
                }
              }
            });
          }}
          style={{ width: '49%' }}
          variant='contained'
          color='primary'
          className={classes.submit}>
          Submit
        </Button>
        <span>&nbsp;</span>
        <Button
          onClick={() => {
            history.push('/login');
          }}
          style={{ width: '49%' }}
          variant='contained'
          color='primary'
          className={classes.submit}>
          Back
        </Button>
      </div>
      <Grid container>
        <Grid item></Grid>
      </Grid>
    </form>
  );

  if (linkExpired) {
    setTimeout(function () {
      history.push('/login');
    }, 10000);

    pageHeader = <></>;
    form = (
      <form className={classes.formJustify} noValidate>
        <div>
          <Button
            onClick={() => {
              history.push('/login');
            }}
            style={{ width: '30%' }}
            variant='contained'
            color='primary'
            className={classes.submit}>
            Back
          </Button>
        </div>
        <Grid container>
          <Grid item></Grid>
        </Grid>
      </form>
    );
  }
  if (instructionMsg) {
    dialog = <Alert severity='success'>{instructionMsg}</Alert>;
  } else if (errorMsg) {
    dialog = <Alert severity='error'>{errorMsg}</Alert>;
  }
  return (
    <Container component='main' maxWidth='xs'>
      <CssBaseline />
      <div className={classes.paper}>
        {pageHeader}
        {dialog}
        {form}
      </div>
    </Container>
  );
};

export default RequestPasswordReset;
